import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  assignConversationToSpecialist,
  assignConversationToExpertAndSelect,
  rejectConversationFromExpert,
  setBtnActivity,
  hideConversation,
  setShowTools as showToolsAction,
  clearHistoricalTicket,
  setTaggingActive,
  setChatMacroRecommendationsEnabled,
} from '../actions';
import { setMacroWizardPath } from '../actions/searchActions';
import EscalatedTicketComponent from '../components/EscalatedTicketComponent/EscalatedTicketComponent';
import { AVAILABLE } from '../constants/expertAvailability';
import {
  extractSelectedTicketBusinessDetailsFromState,
  extractSelectedHistoricalTicketIdFromState,
  extractTestTicketStatusFromState,
  isSimplrCategoryTaggingActiveForSelectedTicket,
  isSpecialistLite,
  extractSelectedTicketFromState,
  isSelectedTicketReviewTicket,
  getIsExpertDashboardOpened,
  getSimplrTaggingActive,
} from '../extractFromState';
import { getLastPageUrl } from '../util/util';

import { TICKET_ACTION_SOURCES } from '../analytics/ticketEventAnalytics';
import { trackTakeButtonClick } from '../analytics/buttonEventAnalytics';

const mapStateToProps = (state) => {
  let selectedTicket = {
    ticket: extractSelectedTicketFromState(state),
    selectedInboxTab: state.ui.messages.selectedInboxTab,
    isAdmin: state.user.isAdmin,
  };

  return {
    lastPageUrl: getLastPageUrl(selectedTicket),
    btnActivity: state.ui.buttons.btnActivity,
    selectedConversation: state.conversation,
    businessDetailsForTicket: extractSelectedTicketBusinessDetailsFromState(state),
    message: state.conversation && state.conversation[state.conversation.allMessages[0]],
    simplrTaggingRequired: isSimplrCategoryTaggingActiveForSelectedTicket(state),
    showButtons: state.user.isAdmin || state.user.availability === AVAILABLE,
    showTools: state.ui.tools.general.showTools,
    isSelectedHistoricalTicket: !!extractSelectedHistoricalTicketIdFromState(state),
    isTestStoreTicket: extractTestTicketStatusFromState(state),
    simplrTaggingActive: getSimplrTaggingActive(state),
    isSpecialistLite: isSpecialistLite(state),
    selectedTicket,
    currentUser: state.user,
    reviewTicketSelected: isSelectedTicketReviewTicket(state),
    isExpertDashboardOpened: getIsExpertDashboardOpened(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(
      {
        setTaggingActive,
        setBtnActivity,
        clearHistoricalTicket,
        setMacroWizardPath,
        setChatMacroRecommendationsEnabled,
        onHideClick: hideConversation,
        onRejectClick: rejectConversationFromExpert,
        setShowTools: showToolsAction,
      },
      dispatch
    ),
    onTakeClick(conversationId, simplrAccountPtrId, isAdmin, buttonId) {
      trackTakeButtonClick();
      if (isAdmin) {
        dispatch(
          assignConversationToSpecialist(conversationId, 'nominated', buttonId, TICKET_ACTION_SOURCES.NOMINATED_TAB)
        );
      } else {
        dispatch(
          assignConversationToExpertAndSelect(
            conversationId,
            simplrAccountPtrId,
            buttonId,
            TICKET_ACTION_SOURCES.NOMINATED_TAB
          )
        );
      }
    },
  };
};

const EscalatedTicketContainer = connect(mapStateToProps, mapDispatchToProps)(EscalatedTicketComponent);

export default EscalatedTicketContainer;
